import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
	state: false,
	upgradeState : false,
	options: {
		children: null
	}
};
const userSettingsDialog = createSlice({
	name: 'settings',
	initialState: initialState,
	reducers: {
		openDialog: (state: any, action: PayloadAction<any>) => {
			state.state = true;
			state.options = action.payload;
		},
		closeDialog: (state: any) => ({
			...initialState
		}),
		openDialogUpgrade: (state: any, action: PayloadAction<any>) => {
			state.upgradeState = true;
			state.options = action.payload;
		},
		closeDialogUpgrade: (state: any) => ({
			...initialState
		})
	}
});

export const { openDialog, closeDialog, openDialogUpgrade,  closeDialogUpgrade} = userSettingsDialog.actions;

export default userSettingsDialog.reducer;
